import React from "react";
import classNames from "classnames";
import CheckGreyIcon from "../../img/svg/check-grey.svg?react";

export const RolledInfoArrow = ({ isOpened, setIsOpened }) => {
  const toggleArrow = () => {
    setIsOpened(!isOpened);
  };

  return (
    <button
      type="button"
      aria-label="Arrow icon"
      className={classNames("check-grey", { closed: !isOpened })}
      onClick={toggleArrow}
      data-testid="rolled-info-arrow-button">
      <CheckGreyIcon alt="check grey icon" />
    </button>
  );
};
